export default {
  "group": "Agrupación",
  "report": "Reporte",
  "lastDataReportPvt": "Última avaliação Cognus",
  "lastDataReportSleep": "Última avaliação FFD",
  "lastWeekReport": "Última semana",
  "lastMonthReport": "Último mês",
  "lastThreeMonthsReport": "Últimos três meses",
  "lastSixMonthsReport": "Últimos seis meses",
  "lastYearReport": "Último ano",
  "workShiftGroup": "Grupo de turno",
  "reportGroup": "Reporte resumido por",
  "operations": "Operação",
  "client": "Cliente",
  "zone": "Zona",
  "carrier": "Contratada",
  "carriers": "Contratadas",
  "plant": "Planta",
  "from": "Desde",
  "to": "Até",
  "user": "Usuário",
  "closeSession": "Finalizar sessão",
  "profile": "Perfil",
  "noTags": "Sem tags",
  "person": "Pessoa",
  "plantClient": "Geozonas",
  "search": "Procurar",
  "synchrousDate": "fecha sincronización",
  "inspectionDate": "fecha inspección",
  "filterFor": "Filtrar por",
  "date": "Data",
  "inspector": "Inspector",
  "note": "Nota",
  "type": "Tipo",
  "subtype": "Subtipo",
  "form": "Formulario",
  "transporter": "Contratada",
  "driver": "Condutor",
  "team": "Equipo",
  "fails": "Fallas",
  "nodata": "Não há mais dados",
  "indicators": "Indicadores todos los transportistas",
  "FFDResult": "Resumo dos resultados",
  "FFDSync": "Tasa de sincronización",
  "FFDRealization": "Taxa de realização",
  "show": "Mostrar",
  "ffdPvt": "Cognus",
  "ffdSleep": "FFD",
  "sleepWristband": "Pulseras de sueño",
  "pvtTest": "Teste PVT",
  "help": "Ajuda",
  "repeatTour": "Repetir tour",
  "categoryFilters": "Filtros de categorias",
  "cancel": "Cancelar",
  "apply": "Aplicar",
  "ubicationpvt": "Ubicación PVT",
  "contract": "Contrato",
  "typeFilters": "Tipo / Subtipo",
  "customize": "Personalizar",
  "and": "e",
  "more": "mais",
  "all": "TODOS",
  "noMatches": "Não há correspondências"
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/filters/index.js